"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var GridLayout = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e561lpw0"
})(function (props) {
  return {
    display: 'grid',
    gridTemplateColumns: props.gridTemplateColumns || '1fr',
    gridTemplateRows: props.gridTemplateRows || 'auto',
    gridGap: props.gridGap || 0,
    margin: props.margin || 0,
    alignItems: props.alignItems || 'stretch',
    justifyItems: props.justifyItems || 'stretch',
    justifyContent: props.justifyItems || 'normal',
    gridAutoFlow: props.gridAutoFlow || 'row'
  };
});
var _default = GridLayout;
exports.default = _default;